module.exports = __webpack_public_path__ + "img/tc.47c82761.svg";